import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Name', prop: 'name' },
  { title: 'Created', prop: 'created_at', format: 'fromNow' },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const InstitutionSchools = (props) => {
  const defaults = {
    order: [{ column: 'name', direction: 'asc' }],
    filters: {
      institution_id: props.params.institutionId
    }
  }

  return (
    <List
      title='Schools & Colleges'
      apiPath='admin/institution_schools'
      columns={columns}
      defaults={defaults}
      buildMenuItems={menuItems}
      locationPathname={props.location.pathname}
      locationSearch={props.location.search}
    />
  )
}

export default InstitutionSchools
